import React from 'react'
import { Stack, Typography, styled, css } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

const AddToCartCheckmarkStyled = styled(Stack)(
  ({ theme }) => css`
    .AddToCartCheckmark {
      &__Title {
        font-size: 23px;
        margin-left: 7px;
        color: ${theme.palette.success.main};
        ${theme.breakpoints.down('md')} {
          font-size: 19px;
        }
      }

      &__Icon {
        color: ${theme.palette.success.main};
      }
    }
  `,
)

const AddToCartCheckmark = () => (
  <AddToCartCheckmarkStyled direction="row" alignItems="center" className="AddToCartCheckmark">
    <CheckCircleOutlineIcon className="AddToCartCheckmark__Icon" fontSize="medium" sx={{ marginLeft: '-2px' }} />
    <Typography variant="h3" className="AddToCartCheckmark__Title" aria-labelledby="add-to-cart-header">
      Added To Cart
    </Typography>
  </AddToCartCheckmarkStyled>
)

export default AddToCartCheckmark
